"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LandingPageContainer = void 0;
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _testidGenerator = require("@ori/testid-generator");
var _components = require("../components");
var _constants = require("../constants");
var _logger2 = require("../logger");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Component that wraps `LandingPage` with relevant Providers.
 */ const LandingPageContainer = (param)=>{
    let { breadcrumbs, data, articlesProps, className, categoriesProps, hideSectionsTitles } = param;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
        team: _constants.APP_TEAM_NAME,
        project: _constants.APP_NAME,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
            logger: _logger2.mainLogger,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
                areaName: "EditorialLandingPageContainer",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
                    namespace: _constants.translationsNamespace,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.LandingPage, {
                        breadcrumbs: breadcrumbs,
                        data: data,
                        articlesProps: articlesProps,
                        className: className,
                        categoriesProps: categoriesProps,
                        hideSectionsTitles: hideSectionsTitles
                    })
                })
            })
        })
    });
};
exports.LandingPageContainer = LandingPageContainer;
